import { AlpineComponent } from "alpinejs";
import { fetchProductPrice } from "../hooks/fetchProductPrice";

type ProductPrice = AlpineComponent<{
	partNo: string | null;
	unitOfMeasurement: string | null;
	numberOfDecimals: number;
	priceFormatted: string | null;
}>;

export default (partNo: string | null, unitOfMeasurement: string | null, numberOfDecimals = 0): ProductPrice => {
	return {
		async init() {
			if (partNo) {
				this.priceFormatted = await fetchProductPrice(partNo, numberOfDecimals);
			}

			if (unitOfMeasurement) {
				this.priceFormatted = this.priceFormatted ? `${this.priceFormatted}/${unitOfMeasurement}` : null;
			}
		},
		partNo,
		unitOfMeasurement,
		numberOfDecimals,
		priceFormatted: null,
	};
};
